<template>
  <div id="banner">
    <div id="items-wrapper" class="flex items-center">

      <div id="nav-head" class="flex items-center justify-between">
        <router-link id="title-wrap" class="items-center hover-hint" :to="locations[0].route">
          <img src="@/assets/logo.png" alt="CoderJo's Cross Logo" id="logo" />
          <h1>CoderJo</h1>
        </router-link>

        <input id="menu-button-input" class="display-none" type="checkbox" v-model="toggleNavBar" />
        <label for="menu-button-input" id="menu-button" class="flex justify-center items-center hover-hint">
          <iconify-icon mode="svg"
            :icon="toggleNavBar ? 'line-md:menu-to-close-transition' : 'line-md:close-to-menu-alt-transition'">
          </iconify-icon>
        </label>
      </div>

      <nav id="nav-bar" :show="toggleNavBar ? '' : undefined">
        <ul id="nav-list">
          <li v-for="location in locations">
            <router-link class="items-center hover-hint" :to="location.route">
              <p><b>{{ $t("bannerNavList." + location.key) }}</b></p>
            </router-link>
          </li>
        </ul>
        <img id="nav-bar-img" src="@/assets/logo.png" alt="CoderJo's Cross Logo" />
      </nav>
    </div>
  </div>
</template>

<script lang="ts">
import "iconify-icon";
import locations from "@/assets/banner-links.json";
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      locations,
      toggleNavBar: false
    };
  }
});
</script>

<style>
#banner {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;

  box-sizing: border-box;
  width: 100%;
  height: var(--banner-height);
  border-bottom: var(--border-width) solid #464646;

  background-color: var(--banner-background-color);
  color: var(--banner-color);
  user-select: none;
}

#items-wrapper {
  max-width: var(--max-banner-width);
  height: 100%;
  margin: auto;

  flex-flow: row nowrap;
  align-items: stretch;
  justify-content: space-between;
}

#nav-head {
  width: 100%;
}

#menu-button {
  display: none;
}

#title-wrap {
  box-sizing: border-box;
  height: 100%;
  padding: 0.6rem;

  display: flex;
  flex-flow: row nowrap;

  color: inherit;
  text-decoration: none;
}

#banner #logo {
  height: 100%;
  margin-right: 10px;
  padding: 10px;

  image-rendering: pixelated;
  aspect-ratio: 1;
  background-image: radial-gradient(#fffb, transparent 50%);
}


#nav-list {
  height: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  list-style: none;

  font-size: var(--nav-font-size);
}

#nav-list a {
  height: 100%;
  padding: 0 1em;

  display: flex;
  flex-flow: row nowrap;

  text-decoration: none;
  white-space: nowrap;
  color: inherit;

  transition: background-color 0.1s ease-out;
}

#nav-bar-img {
  display: none;
}

@media screen and (max-width: 800px) {
  #menu-button {
    display: flex;
    height: 100%;
    aspect-ratio: 1;
    font-size: 2em;

    /* appearance: none;
    color: unset;
    border: unset; */
  }

  /* :where(#menu-button) {
    background: unset;
  } */

  #nav-bar {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;

    position: fixed;
    top: 0;
    right: calc(-1 * var(--nav-bar-aside-width));

    box-sizing: border-box;
    width: calc(min(50vw, var(--nav-bar-aside-width)));
    height: calc(100vh - var(--banner-height));
    margin-top: var(--banner-height);
    border-left: var(--border-width) solid #464646;

    background-color: var(--nav-bar-aside-bg-color);
    transition: right .4s ease;
  }

  #nav-bar[show] {
    top: 0;
    right: 0;
  }

  #nav-list {
    height: auto;
    flex-flow: column nowrap;
    justify-content: start;
  }

  #nav-list li {
    width: 100%;
  }

  #nav-list a {
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    width: 100%;
    height: auto;
    padding: 1em 0;
  }

  #nav-bar-img {
    display: block;
    margin: 1.8em;
    padding: 1em;
    border-radius: .8em;
    aspect-ratio: 1;
    object-fit: contain;
    image-rendering: pixelated;
    background-color: #d95763;
    box-shadow: 0 0 10px white;
    user-select: none;
  }
}
</style>
